import React from "react";
import { Clock, Calendar } from "lucide-react";
import { UpdateHotelRequest } from "@repo/types";
import { SectionCard, DetailItem } from "./HotelCommon";
import moment from "moment";

interface TimingSectionProps {
  editForm: Partial<UpdateHotelRequest>;
  isEditMode: boolean;
  setEditForm: (form: Partial<UpdateHotelRequest>) => void;
  isActive: boolean;
  proExpireDate?: string;
}

export const TimingSection: React.FC<TimingSectionProps> = ({
  editForm,
  isEditMode,
  setEditForm,
  isActive,
  proExpireDate,
}) => {
  return (
    <SectionCard title="Timings & Status" icon={Clock}>
      <DetailItem
        label="Check-In"
        value={
          editForm.CheckInTime
            ? moment(editForm.CheckInTime, "HH:mm:ss").format("h:mm A")
            : ""
        }
        // value={editForm.CheckInTime || ""}
        isEdit={isEditMode}
        onChange={(val) => setEditForm({ ...editForm, CheckInTime: val })}
        icon={Clock}
      />
      <DetailItem
        label="Check-Out"
        value={
          editForm.CheckOutTime
            ? moment(editForm.CheckOutTime, "HH:mm:ss").format("h:mm A")
            : ""
        }
        // value={editForm.CheckOutTime || ""}
        isEdit={isEditMode}
        onChange={(val) => setEditForm({ ...editForm, CheckOutTime: val })}
        icon={Clock}
      />
      <div className="flex items-center justify-between p-3 rounded-xl bg-gray-50 dark:bg-[#1b254b]/30">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-white dark:bg-[#1b254b] rounded-lg border border-gray-100 dark:border-white/5 text-gray-400 dark:text-slate-500">
            <Clock size={15} />
          </div>
          <span className="text-[10px] font-black text-gray-400 dark:text-slate-500 uppercase tracking-wider">
            Status (Active)
          </span>
        </div>
        {isEditMode ? (
          <input
            type="checkbox"
            checked={editForm.IsActive}
            onChange={(e) =>
              setEditForm({ ...editForm, IsActive: e.target.checked })
            }
            className="w-5 h-5 rounded border-gray-300 dark:border-white/10 text-blue-600 focus:ring-blue-500 bg-white dark:bg-[#1b254b]"
          />
        ) : (
          <span
            className={`text-xs font-bold ${isActive ? "text-emerald-600 dark:text-emerald-400" : "text-red-600 dark:text-red-400"}`}
          >
            {isActive ? "Active" : "Inactive"}
          </span>
        )}
      </div>
      <DetailItem
        label="Expires On"
        value={
          proExpireDate
            ? moment(proExpireDate).format("D MMM YYYY")
            : // ? new Date(proExpireDate).toLocaleDateString()
              "N/A"
        }
        icon={Calendar}
      />
    </SectionCard>
  );
};
